import { apiFetch } from "./client";

/**
 * Ključ kojim portal potpisuje pristupne tokene.
 *
 * ACTIVE je onaj kojim se potpisuje sad; RETIRED se više ne potpisuje ali se još priznaje, da token
 * izdat pre minut ne bi prestao da radi; REVOKED ne radi ništa od toga.
 */
export type JwtKeyStatus = "ACTIVE" | "RETIRED" | "REVOKED";

export type JwtKey = {
  id: number;
  status: JwtKeyStatus;
  validFrom: string;
  retiredAt: string | null;
  revokedAt: string | null;
  createdBy: string | null;
  /** Ime onoga ko je ključ napravio rukom; prazno kad ga nije napravio čovek nego zakazani posao. */
  createdByName: string | null;
  createdAt: string;
};

/** Pravilo koje važi: da li zakazana promena radi, na koliko dana, i koliko se stari ključ još priznaje. */
export type JwtRotationPolicy = {
  enabled: boolean;
  intervalDays: number;
  graceWindowDays: number;
};

export type JwtKeys = {
  rotation: JwtRotationPolicy;
  keys: JwtKey[];
};

export const jwtKeyApi = {
  list: () => apiFetch<JwtKeys>("/admin/security/jwt-keys"),
  /** Menja ključ sada. Vraća isto što i čitanje, pa ekran posle promene nema šta drugo da traži. */
  rotate: () => apiFetch<JwtKeys>("/admin/security/jwt-keys/rotate", { method: "POST" }),
};
